import './Video.scss';

import * as React from 'react';
import { graphql, StaticQuery, Link } from 'gatsby';
import { find } from 'lodash';

import { Video as VideoType } from 'components/videos/types';
import Tag from 'components/videos/Tag';

type Props = {
  video: VideoType;
  showTags?: boolean;
  schedules: {
    year: number;
    iconImageURL: string;
  }[];
};

function Video(props: Props) {
  const { video, showTags, schedules } = props;
  const schedule = find(schedules, { year: video.year });

  return (
    <div className="Video">
      <Link to={`/${video.year}/videos/${video.slug}`}>
        <div className="Video-previewThumbnail">
          <img
            className="Video-previewThumbnail-image"
            src={`https://img.youtube.com/vi/${video.src}/0.jpg`}
          />
        </div>
      </Link>

      <div className="Video-header">
        <Link to={`/${video.year}/videos/${video.slug}`}>
          <h3 className="Video-header-title">{video.title}</h3>
          <div className="Video-header-subtitle">{video.subtitle}</div>
        </Link>
        <Link to={`/${video.year}`}>
          <img src={schedule.iconImageURL} className="Video-header-yearIcon" />
        </Link>
      </div>

      {showTags && (
        <div className="Video-tagWrapper">
          <Tag tag={video.year.toString()} to={`/${video.year}/videos`} />
          {video.tags.map((tag) => (
            <Tag key={tag} tag={tag} to={`/videos/${tag}`} />
          ))}
        </div>
      )}
    </div>
  );
}

Video.defaultProps = { showTags: true };

export default function VideoQuery(props) {
  return (
    <StaticQuery
      query={graphql`
        query VideoSchedules {
          schedules: allSchedule(filter: { published: { eq: true } }) {
            nodes {
              year
              iconImageURL
            }
          }
        }
      `}
      render={(data) => {
        const schedules = data.schedules.nodes;

        return <Video schedules={schedules} {...props} />;
      }}
    />
  );
}
